import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import { en } from "./utils/translations/en";
import { pt } from "./utils/translations/pt";

i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        fallbackLng: 'pt',
        resources: {
            en: {
                translation: en
            },
            pt: {
                translation: pt
            }
        }
    });